// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/milestone.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/milestone.proto.
 */
export const file_pull_requests_v1_milestone: GenFile = /*@__PURE__*/
  fileDesc("CiBwdWxsX3JlcXVlc3RzL3YxL21pbGVzdG9uZS5wcm90bxIXZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEidwoRTWlsZXN0b25lUmVzcG9uc2USQAoJbWlsZXN0b25lGAEgASgLMi0uZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuUHVsbFJlcXVlc3RNaWxlc3RvbmUSIAoYdmlld2VyX2Nhbl9zZXRfbWlsZXN0b25lGAIgASgIIq8BChRQdWxsUmVxdWVzdE1pbGVzdG9uZRIKCgJpZBgBIAEoAxIPCgdub2RlX2lkGAIgASgJEg0KBXRpdGxlGAMgASgJEg4KBm51bWJlchgEIAEoBRILCgN1cmwYBSABKAkSDgoGY2xvc2VkGAYgASgIEhEKCWNsb3NlZF9hdBgHIAEoCRIOCgZkdWVfb24YCCABKAkSGwoTcHJvZ3Jlc3NfcGVyY2VudGFnZRgJIAEoAWIGcHJvdG8z");

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/milestone
 *
 * Defined by PullRequests::PageData::MilestonesController#index.
 *
 * @generated from message github.pull_requests.v1.MilestoneResponse
 */
export type MilestoneResponse = Message<"github.pull_requests.v1.MilestoneResponse"> & {
  /**
   * @generated from field: github.pull_requests.v1.PullRequestMilestone milestone = 1;
   */
  milestone?: PullRequestMilestone;

  /**
   * @generated from field: bool viewer_can_set_milestone = 2;
   */
  viewerCanSetMilestone: boolean;
};

/**
 * Describes the message github.pull_requests.v1.MilestoneResponse.
 * Use `create(MilestoneResponseSchema)` to create a new message.
 */
export const MilestoneResponseSchema: GenMessage<MilestoneResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_milestone, 0);

/**
 * Named `PullRequestMilestone` rather than `Milestone` to avoid colliding with
 * other milestone messages; message names share the `github.pull_requests.v1`
 * package namespace.
 *
 * @generated from message github.pull_requests.v1.PullRequestMilestone
 */
export type PullRequestMilestone = Message<"github.pull_requests.v1.PullRequestMilestone"> & {
  /**
   * Database id; used to submit removal.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * Global relay / GraphQL node id; used by the sidebar milestone picker to
   * mark the current selection and to diff against picked milestones.
   *
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: int32 number = 4;
   */
  number: number;

  /**
   * @generated from field: string url = 5;
   */
  url: string;

  /**
   * @generated from field: bool closed = 6;
   */
  closed: boolean;

  /**
   * @generated from field: string closed_at = 7;
   */
  closedAt: string;

  /**
   * @generated from field: string due_on = 8;
   */
  dueOn: string;

  /**
   * @generated from field: double progress_percentage = 9;
   */
  progressPercentage: number;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestMilestone.
 * Use `create(PullRequestMilestoneSchema)` to create a new message.
 */
export const PullRequestMilestoneSchema: GenMessage<PullRequestMilestone> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_milestone, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(MilestoneResponseSchema, "7fe1f96e6fea")
registerSchemaHash(PullRequestMilestoneSchema, "8388761caf3f")
